import { Component, OnInit, Input } from '@angular/core';

/**
 * Component per mostrar el marcador d'un parking
 */ 
@Component({
  selector: 'app-parking',
  templateUrl: './parking.component.html',
  styleUrls: ['./parking.component.css']
})
export class ParkingComponent implements OnInit {

  /**
   * Feature que conté les propietats per crear el marcador
   */
  @Input() feature;

  /**
   * Capa a la qual pertany el marcador
   */
  @Input() layer;

  /**
   * Conté les propietats del feature
   */
  properties;

  /**
   * Url de la icona a mostrar
   */
  iconUrl: string;

  /**
   * Nom del pàrking
   */
  name: string; 

  /**
   * Adreça del pàrking
   */
  address: string;

  /**
   * Horari del pàrking
   */
  timetable: string;

  /**
   * Tarifes del pàrking
   */
  price: string;

  /**
   * Número de telèfon del pàrking
   */
  phone: string;

  /**
   * Tipus de pàrking
   */
  type: string;

  /**
   * Capacitat del pàrking
   */
  size: number;

  /**
   * Operador del parking
   */
  operador: string;

  /**
   * URL del pàrking al portal Parkopedia
   */
  urlParkopedia: string; 

  /**
   * @ignore
   */
  constructor() { }

  /**
   * Inicialitza les propietats del component
   */
  ngOnInit() {

    this.properties = this.feature.properties;
    this.iconUrl = 'assets/img/' + this.layer + '_MARKER.svg';
    this.name = this.properties.nom;
    this.address = this.properties.adressa;
    if(this.properties.poblacio) this.properties.address = this.properties.address +  ", " + this.properties.poblacio;
    this.timetable = this.properties.horari;
    this.price = this.properties.tarifes;
    this.phone = this.properties.telefon;
    this.type = this.properties.tipus;
    this.size = this.properties.capacitat;
    this.operador = this.properties.operador;
    this.urlParkopedia = this.properties.url;
  }

}
